"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INNERLINE_STROKE_WIDTH = exports.INNERLINE_STROKE = exports.OUTERLINE_STROKE_WIDTH = exports.OUTERLINE_STROKE = exports.CALIPER_INNERLINE_STROKE_WIDTH = exports.CALIPER_INNERLINE_STROKE = exports.CALIPER_OUTERLINE_STROKE_WIDTH = exports.CALIPER_OUTERLINE_STROKE = exports.Style = exports.CSS = void 0;
exports.CSS = {
    image: 'c-PMZoom__Image',
    container: 'c-PMZoom__Container',
    crosshair: 'c-PMZoom__Crosshair',
    crosshairOuterline: 'c-PMZoom__Outerline',
    crosshairInnerline: 'c-PMZoom__Innerline',
    crosshairCaliper: 'c-PMZoom__Caliper'
};
exports.Style = {
    [exports.CSS.container]: {
        position: 'relative'
    },
    [exports.CSS.image]: {
        position: 'absolute',
        'transform-origin': 'top left',
        top: 0,
        left: 0
    },
    [exports.CSS.crosshair]: {
        position: 'absolute'
    }
};
exports.CALIPER_OUTERLINE_STROKE = 'black';
exports.CALIPER_OUTERLINE_STROKE_WIDTH = '1.5px';
exports.CALIPER_INNERLINE_STROKE = 'white';
exports.CALIPER_INNERLINE_STROKE_WIDTH = '1px';
exports.OUTERLINE_STROKE = 'black';
exports.OUTERLINE_STROKE_WIDTH = '2.5px';
exports.INNERLINE_STROKE = 'white';
exports.INNERLINE_STROKE_WIDTH = '2px';
//# sourceMappingURL=zoom.style.js.map